// extracted by mini-css-extract-plugin
export default {"rowPopup":"CurrencyDropDown_rowPopup__MWcOQ","horizontalLine":"CurrencyDropDown_horizontalLine__mRJsl","totalValue":"CurrencyDropDown_totalValue__qecdJ"};